var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.1437 90.7183H70.1437V85.7183V75.4306V70.4306H65.1437H54.8559H49.8559V75.4306V85.7183V90.7183H54.8559H65.1437ZM13.5613 59.9991C13.5613 34.3664 34.3672 13.5605 59.9998 13.5605C85.6324 13.5605 106.438 34.3664 106.438 59.9991C106.438 85.6317 85.6324 106.438 59.9998 106.438C34.3672 106.438 13.5613 85.6317 13.5613 59.9991ZM49.8559 59.9991C49.8559 65.5896 54.4093 70.1429 59.9998 70.1429C65.5903 70.1429 70.1437 65.5896 70.1437 59.9991V39.4237C70.1437 33.8331 65.5903 29.2798 59.9998 29.2798C54.4093 29.2798 49.8559 33.8331 49.8559 39.4237V59.9991Z",
    fill: "url(#paint0_linear_1450_20951)",
    stroke: "url(#paint1_linear_1450_20951)",
    strokeWidth: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1450_20951",
    x1: 60.0173,
    y1: 8.56055,
    x2: 94.9866,
    y2: 97.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1450_20951",
    x1: 60.0173,
    y1: 8.56055,
    x2: 94.9866,
    y2: 97.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A011"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon404);
export default __webpack_public_path__ + "static/media/icon_404.978272bb3cc8250f10a8571c45a3dfaf.svg";
export { ForwardRef as ReactComponent };